export default function formatTagName(tag: {
  name: string;
  group?: { name: string } | null;
}): string {
  return tag.group ? `${tag.group.name} > ${tag.name}` : tag.name;
}
